/**
 * Ableitung des Eltern-Vorgangs eines To-dos. DOM-frei/unit-testbar.
 *
 * Seit dem Wegfall der To-do-Detailseite ist das das Ziel der Weiterleitung
 * `/todos/:id` → `/vorgaenge/:vorgangId` (siehe `TodoRedirectPage`). Ein To-do
 * gehört immer zu einem Vorgang; kann der Eltern-Vorgang wider Erwarten (bzw.
 * mangels Sichtbarkeit) nicht bestimmt werden, liefert der Pfad `null` und die
 * Weiterleitung meldet das sauber, statt auf `/vorgaenge/undefined` zu landen.
 *
 * Beide Quellen bleiben nötig: `vorgang.id` liefert der volle Lesepfad
 * (`GET /todo/:id` lädt die Relation), `vorgangId` kommt aus DTOs, die die Id
 * flach mitgeben.
 */

export interface BacklinkTodoLike {
    vorgang?: { id?: number | null } | null;
    vorgangId?: number | null;
}

/** Eltern-Vorgang-Id (`vorgang.id` bevorzugt, sonst `vorgangId`). */
export function parentVorgangIdOf(todo: BacklinkTodoLike | null | undefined): number | null {
    const id = todo?.vorgang?.id ?? todo?.vorgangId ?? null;
    return typeof id === "number" && Number.isFinite(id) ? id : null;
}

/** Ziel `/vorgaenge/:vorgangId` oder `null`. */
export function todoBacklinkPath(todo: BacklinkTodoLike | null | undefined): string | null {
    const vorgangId = parentVorgangIdOf(todo);
    return vorgangId != null ? `/vorgaenge/${vorgangId}` : null;
}

/**
 * Ziel der Weiterleitung `/todos/:id`: der Eltern-Vorgang MIT aufgeklapptem
 * To-do (`?todo=<id>`, User 01.11.2026) — sonst stünde man im Vorgang und
 * müsste das gemeinte To-do erst suchen. `null` wie {@link todoBacklinkPath}.
 */
export function todoSprungPath(
    todo: (BacklinkTodoLike & { id?: number | null }) | null | undefined,
    todoId?: number | null,
): string | null {
    const basis = todoBacklinkPath(todo);
    if (!basis) return null;
    const id = todoId ?? todo?.id ?? null;
    return typeof id === "number" && Number.isFinite(id) && id > 0 ? `${basis}?todo=${id}` : basis;
}
